import { createContext, useContext } from "react";
import { initializePaddle, type InitializePaddleOptions, type Paddle, type PaddleEventData } from "@paddle/paddle-js";
import { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";

const PaddleContext = createContext<Paddle | undefined>(undefined);

export function PaddleProvider({ children }: { children: React.ReactNode }) {
  const [paddle, setPaddle] = useState<Paddle | null>(null);

  useEffect(() => {
    const setupPaddle = async () => {
      try {
        const paddleInstance = await initializePaddle(paddleOpts);
        if (paddleInstance) setPaddle(paddleInstance);
      } catch (error) {
        Sentry.captureException(error);
      }
    };

    setupPaddle();
  }, []);

  if (!paddle) return null;

  return (
    <PaddleContext.Provider value={paddle}>
      {children}
    </PaddleContext.Provider>
  );
}

export function usePaddle(): Paddle {
  const context = useContext(PaddleContext);
  if (context === undefined) {
    throw new Error('usePaddle must be used within a PaddleProvider');
  }
  return context;
}

export const eventCallback = (eventData: PaddleEventData) => {
  if (eventData.name == "checkout.loaded") {

    const txn_event_id = `InitiateCheckout_${eventData.data.transaction_id}`
    if (window.zaraz) {
      zaraz.ecommerce("Checkout Started", {
        txn_event_id,
        checkout_id: eventData.data.id,
        order_id: eventData.data.transaction_id,
      });
    }
  } else if (eventData.name == "checkout.customer.created") {
    if (window.zaraz) {
      zaraz.set('email', eventData.data.customer.email);
      zaraz.set('postal_code', eventData.data.customer.address?.postal_code);
      zaraz.set('region', eventData.data.customer.address?.region);
    }
  } else if (eventData.name === "checkout.customer.updated") {

  } else if (eventData.name === "checkout.payment.selected") {
    if (window.zaraz) {
      zaraz.ecommerce("Payment Info Entered", {
        checkout_id: eventData.data.id,
        order_id: eventData.data.transaction_id,
        affiliation: eventData.data.custom_data?.affiliate_id,
        coupon: eventData.data.discount?.code,
        payment_type: eventData.data.payment.method_details?.type
      });
    }
  } else if (eventData.name === "checkout.completed") {
    console.log("Checkout complete sending zaraz info");
    var email = eventData.data?.customer.email;
    var uid = eventData.data?.customer.id;
    if (window.fpr) {
      window.fpr("referral", { email, uid });
    }

    const revenue = eventData.data.totals.total - eventData.data.totals.tax;
    const txn_purchase_event_id = `Purchase_${eventData.data.transaction_id}`

    if (window.zaraz) {
      //TODO: include line-items (product / price?) - see eventData.data.items[]
      zaraz.ecommerce("Order Completed", {
        txn_event_id: txn_purchase_event_id,
        checkout_id: eventData.data.id,
        order_id: eventData.data.transaction_id,
        affiliation: eventData.data.custom_data?.affiliate_id,
        total: eventData.data.totals.total,
        revenue,
        tax: eventData.data.totals.tax,
        discount: eventData.data.totals.discount,
        coupon: eventData.data.discount?.code,
        currency: eventData.data.currency_code,
      });
    }

    window.location.reload();
  }
  else if (eventData.name === "checkout.closed") {
  }
}

const paddleOpts: InitializePaddleOptions = {
  environment: import.meta.env.VITE_REACT_APP_PADDLE_ENVIRONMENT,
  token: import.meta.env.VITE_REACT_APP_PADDLE_CLIENT_KEY,
  pwCustomer: {
  },
  eventCallback,
}

export default usePaddle;
